export const QUICK_DESTINATION_IDS = Object.freeze([
  'conversations',
  'kanban',
  'tasks',
  'agenda',
]);

const STORAGE_PREFIX = 'workspace_v2_last_destination';
const conversationRouteNames = new Set([
  'home',
  'inbox_dashboard',
  'inbox_conversation',
  'conversation_through_inbox',
  'label_conversations',
  'conversations_through_label',
  'team_conversations',
  'conversations_through_team',
  'folder_conversations',
  'conversations_through_folders',
  'conversation_mentions',
  'conversation_through_mentions',
  'conversation_unattended',
  'conversation_through_unattended',
  'conversation_unread',
  'conversation_through_unread',
  'conversation_participating',
  'conversation_through_participating',
]);

export const quickDestinationsFor = worlds =>
  QUICK_DESTINATION_IDS.map(id =>
    worlds
      .flatMap(world => world.destinations)
      .find(destination => destination.id === id)
  ).filter(Boolean);

export const quickToolForRoute = (route, worlds) => {
  if (
    route.query?.config_center === '1' ||
    (route.name === 'kanban_board' && route.query?.view === 'configure') ||
    (route.name === 'tasks' && route.query?.task_settings)
  )
    return null;
  const quickDestinations = quickDestinationsFor(worlds);
  if (
    conversationRouteNames.has(route.name) &&
    quickDestinations.some(destination => destination.id === 'conversations')
  ) {
    return 'conversations';
  }
  if (route.name === 'kanban_board' && route.query?.view === 'agenda') {
    return quickDestinations.some(destination => destination.id === 'agenda')
      ? 'agenda'
      : null;
  }
  const destination = worlds
    .flatMap(world => world.destinations)
    .find(item => item.routeName === route.name);

  return destination && QUICK_DESTINATION_IDS.includes(destination.id)
    ? destination.id
    : null;
};

const storageKey = (accountId, destinationId) =>
  `${STORAGE_PREFIX}:${accountId}:${destinationId}`;
const sessionDestinations = new Map();

export const readQuickDestination = (accountId, destinationId) => {
  if (!accountId) return '';
  const saved =
    sessionDestinations.get(storageKey(accountId, destinationId)) || '';
  return saved.startsWith(`/app/accounts/${accountId}/v2/`) ? saved : '';
};

export const writeQuickDestination = (accountId, destinationId, fullPath) => {
  if (!accountId || !fullPath) return;
  sessionDestinations.set(storageKey(accountId, destinationId), fullPath);
};
